import React from 'react';
import { ServicesConsumer } from 'containers/ServicesProvider';

/**
 * Enhances a component so that it may receive every courseware service
 *   from the Services context as a property.
 * @param {ReactComponent} Component The component to wrap
 */
const withServices = (Component) => (props) => (
  <ServicesConsumer>
    {({
      activityService,
      annotationService,
      scenarioService,
      favoritesService,
      recentService,
      pluginService,
      templateService,
      interactiveService,
      componentService,
      pathwayService,
      projectService,
      scopeService,
      themeService,
    }) => (
      <Component
        {...props}
        activityService={activityService}
        annotationService={annotationService}
        scenarioService={scenarioService}
        pluginService={pluginService}
        favoritesService={favoritesService}
        recentService={recentService}
        templateService={templateService}
        interactiveService={interactiveService}
        componentService={componentService}
        pathwayService={pathwayService}
        projectService={projectService}
        scopeService={scopeService}
        themeService={themeService}
      />
    )}
  </ServicesConsumer>
);

export default withServices;
